import React, { useState, useEffect } from 'react';
import { makeStyles, Paper, Button } from '@material-ui/core';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@material-ui/core/IconButton';
import DeleteDialog from './DeleteDialog';
import Tooltip from '@mui/material/Tooltip';
import DevExDataTable from './DevExDataTable';
import { dataService } from '../../services/data/data.service';
import CrudAddEditDrawer from './CrudAddEditDrawer';
import AlreadyExistsDialog from './AlreadyExistsDialog';
import AlreadySentDialog from './AlreadySentDialog';
import ImportExcelModal from './ImportExcelModal';

import { locale, loadMessages } from "devextreme/localization";
import * as nlMessages from "devextreme/localization/messages/nl.json";
import { HubConnectionBuilder } from '@microsoft/signalr';
import * as apiHelper from '../../utils/apiHelper';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

export default function RegistrationsPage(props) {
    const classes = useStyles();
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteId, setDeleteId] = useState(0);
    const [toBeDeleted, setToBeDeleted] = useState(0);
    const [columns, setColumns] = useState([]);
    const [drawerColumns, setDrawerColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [reload, setReload] = useState(false);
    const [crudTitle, setTitle] = useState("");
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [foreignObjects, setForeignObject] = useState({});
    const [selection, setSelection] = useState([]);
    const [exportSelection, setExportSelection] = useState([]);
    const [openAlreadyExistsDialog, setOpenAlreadyExistsDialog] = useState(false);
    const [objectToSave, setObjectToSave] = useState({});
    const [existingRegistration, setExistingRegistration] = useState({});
    const [openRegistrationAlreadySentDialog, setRegistrationAlreadySent] = useState(false);
    const [customerId, setCustomerId] = useState(null);

    const [openImport, setOpenImport] = useState(false);
    const handleOpenImport = () => setOpenImport(true);
    const handleCloseImport = () => setOpenImport(false);

    const setCurrentLanguage = (lang) => {
        switch (lang) {
            case "nl":
                return "nl-BE"
            case "fr":
                return "fr-FR"
            case "EN":
                return "en-US"
        }
    }


    useEffect(() => {
        initMessages();
        setLocale("nl-BE");
        sessionStorage.setItem("locale", "nl-BE");
        dataService.getUser(props.user.userid).then(response => {
            setCustomerId(response.data.customerId);
        }, error => {
            console.log("failed fetching user");
        }
        );
        loadMessages(nlMessages);
        locale("nl-BE");

        if (reload === true) {
            setReload(false);
        }

        let foreign = {};

        foreign.periodUnit = ["Dag", "Maand", "Jaar"];


        let tempColumns = [
            { name: 'originName', title: "Stad" },
            { name: 'postCode', title: "Postcode" },
            { name: 'wasteStreamDescription', title: "Afvalfractie" },
            { name: 'materialDescription', title: "Materiaal" },
            { name: 'strQuantity', title: "Hoeveelheid" },
            { name: 'strPrice', title: "Prijs" },
            { name: 'uom', title: "Eenheid" },
            { name: 'strPeriodValue', title: "Maand" },
            { name: 'strSentToMatis', title: "Verzonden naar Matis" },

        ]
        if (JSON.stringify(tempColumns) !== JSON.stringify(columns)) {
            setColumns(tempColumns);
        }

        let tempDrawerColumns = [
            { name: 'id', title: 'id', isPrimaryKey: 'True', isForeignKey: 'False', dataType: 'int', showInGrid: 'false', editable: 'False' },
            { name: 'processedFileId', title: 'Bestand', isPrimaryKey: 'False', isForeignKey: 'True', dataType: 'int', showInGrid: 'True', editable: 'False' },
            { name: 'collectionMethodId', title: 'Inzamelwijze', isPrimaryKey: 'False', isForeignKey: 'True', dataType: 'int', showInGrid: 'false', editable: 'True' },
            { name: 'collectionMethodComment', title: 'Inzamelwijze commentaar', isPrimaryKey: 'False', isForeignKey: 'False', dataType: 'collectionMethodComment', showInGrid: 'false', editable: 'True' },
            { name: 'originId', title: 'Oorsprong', isPrimaryKey: 'False', isForeignKey: 'True', dataType: 'int', showInGrid: 'false', editable: 'True' },
            { name: 'destinationId', title: 'Bestemming', isPrimaryKey: 'False', isForeignKey: 'True', dataType: 'int', showInGrid: 'false', editable: 'True' },
            { name: 'materialId', title: 'Materiaal', isPrimaryKey: 'False', isForeignKey: 'True', dataType: 'int', showInGrid: 'false', editable: 'True' },
            { name: 'strQuantity', title: 'Hoeveelheid', isPrimaryKey: 'False', isForeignKey: 'False', dataType: 'numeric', showInGrid: 'True', editable: 'True' },
            { name: 'strPrice', title: 'Prijs', isPrimaryKey: 'False', isForeignKey: 'False', dataType: 'numeric', showInGrid: 'True', editable: 'True' },
            { name: 'unitOfMeasurementId', title: 'Eenheid', isPrimaryKey: 'False', isForeignKey: 'True', dataType: 'int', showInGrid: 'False', editable: 'True' },
            { name: 'periodValue', title: 'Periode', isPrimaryKey: 'False', isForeignKey: 'False', dataType: 'dateTimeWithT', showInGrid: 'false', editable: 'True' },
            { name: 'periodUnit', title: 'Tijdspanne', isPrimaryKey: 'False', isForeignKey: 'True', dataType: 'nvarchar', showInGrid: 'false', editable: 'True' },
            { name: 'momentInsert', title: 'moment insert', isPrimaryKey: 'False', isForeignKey: 'False', dataType: 'nvarchar', showInGrid: 'false', editable: 'False' },
            { name: 'userIdInsert', title: 'user id', isPrimaryKey: 'False', isForeignKey: 'False', dataType: 'int', showInGrid: 'false', editable: 'False' }
        ]
        if (JSON.stringify(tempDrawerColumns) !== JSON.stringify(drawerColumns)) {
            setDrawerColumns(tempDrawerColumns);
        }
        getRegistrations();

        dataService.getAllDestinations().then(
            destinationResult => {
                if (destinationResult) {
                    if (destinationResult.ok) {
                        foreign.destinationId = destinationResult.data.sort((a, b) => a.name.localeCompare(b.name));

                    } else {
                        console.log("Destinations result not ok");
                    }
                }
            },
            error => {
                console.log("Failed fetching destinations");
            }
        );

        dataService.GetOrigins().then(
            originResult => {
                if (originResult) {
                    if (originResult.ok) {
                        var filtered = originResult.data.filter(x => x.isActive === true);
                        foreign.originId = filtered.sort((a, b) => a.name.localeCompare(b.name));

                    } else {
                        console.log("Origin result not ok");
                    }
                }
            },
            error => {
                console.log("Failed fetching origins");
            }
        );

        dataService.GetCollectionMethods().then(
            collectionMethodResults => {
                if (collectionMethodResults) {
                    if (collectionMethodResults.ok) {
                        foreign.collectionMethodId = collectionMethodResults.data.sort((a, b) => a.name.localeCompare(b.name));

                    } else {
                        console.log("Collection methods result not ok");
                    }
                }
            },
            error => {
                console.log("Failed fetching Collection methods");
            }
        );

        dataService.GetUnitOfMeasurements().then(
            uomResult => {
                if (uomResult) {
                    if (uomResult.ok) {

                        foreign.unitOfMeasurementId = uomResult.data;

                    } else {
                        console.log("Measurements result not ok");
                    }
                }
            },
            error => {
                console.log("Failed fetching Measurements");
            }
        );

        dataService.GetMaterials().then(
            materialResult => {
                if (materialResult) {
                    if (materialResult.ok) {
                        foreign.materialId = materialResult.data.sort((a, b) => a.materialDescription.localeCompare(b.materialDescription));
                        foreign.materialId.forEach(x => {
                            x.materialDescription = x.materialDescription.charAt(0).toUpperCase() + x.materialDescription.slice(1);
                        })
                        if (JSON.stringify(foreign) !== JSON.stringify(foreignObjects)) {
                            setForeignObject(foreign);
                        }
                    } else {
                        console.log("material result not ok");
                    }
                }
            },
            error => {
                console.log("failed fetching registrations");
            }
        );

        const newHubConnection = new HubConnectionBuilder().withUrl(props.appSettings.DATATRANSFORM_HUB_URL).withAutomaticReconnect().build();
        newHubConnection.on('RegistrationsRefresh', message => {
            console.log("Refresh the registrations! ");
            getRegistrations();


        });
        newHubConnection.start().then(_ => {
        }).catch(e => console.log('Refresh registrations connection failed: ', e));
    }, [reload]);
    const getRegistrations = () => {
        dataService.getAllRegistrations().then(
            registrationsResult => {
                if (registrationsResult) {
                    if (registrationsResult.ok) {
                        registrationsResult.data.forEach(x => {
                            // x.quantity = x.quantity.toFixed(2);
                            //SC 13/04/2022 - Getallen weergeven met komma ipv punt, op vraag van Jurgen
                            // x.quantity = (x.quantity).replace(/\./g, ',');
                            x.strQuantity = parseFloat(x.quantity);
                            x.strPrice = parseFloat(x.price);
                            x.materialDescription = x.materialDescription.charAt(0).toUpperCase() + x.materialDescription.slice(1);
                            x.strSentToMatis = (x.sentToMatis === '0001-01-01T00:00:00' ? '/' : new Date(x.sentToMatis).toLocaleString().replace(',', ''));
                            let split = x.periodValue.substring(0, 7).split('-');
                            x.strPeriodValue = split[1] + '-' + split[0];

                            // x.sentToMatis = (x.sentToMatis === '0001-01-01T00:00:00' ? '/' : new Date(x.sentToMatis).toLocaleString().replace(',', ''));

                        });
                        setRows(registrationsResult.data);
                    } else {
                        console.log("registrations result not ok");
                    }
                }
            },
            error => {
                console.log("failed fetching materials");
            }
        );
    }

    const initMessages = () => {

        loadMessages(nlMessages);

    }
    const setLocale = (savingLocale) => {
        sessionStorage.setItem("locale", savingLocale);
    }

    const openDrawer = (title, open, id) => {
        setTitle(title);
        setDrawerOpen(open);
        setEditId(id);
    }

    const sentToMatisFormatter = (row) => (
        <React.Fragment>
            {row.value === "/" ?
                <RemoveCircleOutlineIcon color={'error'}></RemoveCircleOutlineIcon>
                :
                <div>{row.value}</div>
            }
        </React.Fragment>
    );

    const quantityFormatter = (row) => (
        <React.Fragment>
            {parseFloat(row.value).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </React.Fragment>
    );
    const priceFormatter = (row) => (
        <React.Fragment>
            {row.value < 0 ?
                <span style={{ color: 'red' }}>€ {parseFloat(row.value).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                : <span >€ {parseFloat(row.value).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            }
        </React.Fragment>
    );
    const ActionFormatter = (row) => (
        <React.Fragment>
            <IconButton className={props.user.isInterCommunales ? classes.actionButton : classes.actionButtonDisabled} onClick={() => editRow(row.row.id)} title={"Rijen aanpassen"} disabled={!props.user.isInterCommunales}>
                <EditIcon />
            </IconButton>
            <IconButton className={props.user.isInterCommunales ? classes.actionButton : classes.actionButtonDisabled} onClick={() => deleteRow(row.row)} disabled={!props.user.isInterCommunales}>
                <DeleteIcon />
            </IconButton>
        </React.Fragment>
    );

    const editRow = (id) => {
        openDrawer("Aanpassen", true, id);
    };

    const addRow = () => {
        openDrawer("Toevoegen", true, null);
    };


    function setDateTime(dateTime) {
        const [date, time] = dateTime.split(" ");
        const [DD, MM, YYYY] = date.split("-");
        const [h, m, s] = time.split(":");
        return new Date(YYYY, MM - 1, DD, h, m, s);
    }
    const exportRows = () => {
        let filteredRows = rows.filter(x => (selection.some(y => y === rows.indexOf(x)) && (x.requiredForMatis === true)));
        setExportSelection(filteredRows);
        console.log('Export props', props, props.user.userid)
        //SC: Send selected rows to nodered service which will make an excel file for us. Download this file in the response.
        dataService.convertSelected(filteredRows, props.user.userid).then((response) => {
            console.log(response)
            if (response.data !== null) {
                let filename = response.data.filename;
                const link = document.createElement('a');
                let href = '';
                href = '/processed/' + filename;

                link.href = href;
                link.target = '_blank'
                link.setAttribute('download', filename);
                // Append to html link element page
                document.body.appendChild(link);
                // Start download
                link.click();
                // Clean up and remove the link
                link.parentNode.removeChild(link);

            } else {
                toast.error('Er liep iets mis!', { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });

            }

        });

    };


    const deleteRow = (row) => {
        setToBeDeleted(row);
        setDeleteId(row.id);
        setOpenDeleteDialog(true);
    };

    const handleClose = () => {
        setOpenDeleteDialog(false);
    };

    const handleCloseDialog = () => {
        setOpenAlreadyExistsDialog(false);
    };
    const handleCloseSentDialog = () => {
        setRegistrationAlreadySent(false);
    };
    const handleSaveDialog = () => {
        if (Object.keys(objectToSave).length > 0) {
            dataService.saveRegistration(objectToSave).catch((error) => {
                console.log("failed editing registration row");
            });
        }
        setOpenAlreadyExistsDialog(false);
        setRegistrationAlreadySent(false);

        openDrawer("", false, null);
        setReload(true);



    };
    const handleCombine = () => {
        if (Object.keys(objectToSave).length > 0) {
            objectToSave.Quantity = objectToSave.Quantity + Number((existingRegistration.quantity).replace(',', '.'));
            objectToSave.Price = objectToSave.Price + Number((existingRegistration.quantity).replace(',', '.'));
            objectToSave.IdentificationCode = existingRegistration.identificationCode;
            objectToSave.Id = existingRegistration.id;
            objectToSave.Edit = true;
            objectToSave.MomentInsert = existingRegistration.MomentInsert;
            objectToSave.UserIdUpdate = props.user.userid;
            objectToSave.UserIdUpdate = props.user.userid;

            dataService.saveRegistration(objectToSave).catch((error) => {
                console.log("failed editing registration row");
            });
            setOpenAlreadyExistsDialog(false);
            openDrawer("", false, null);
            setReload(true);
        }
    };
    const handleDelete = (id) => {
        setOpenDeleteDialog(false);
        dataService.deleteRegistration(id).then(() => {
            setReload(true);
        }).catch((error) => {
            console.log("failed deleting registration row")
        });
    };

    return (
        <div className={classes.container}>
            <div className={classes.buttonContainer}>
                <Tooltip title={"Importeer excel"}>
                    <Button className={classes.exportButton} variant="contained" onClick={handleOpenImport} disabled={!props.user.isInterCommunales}>{"Importeer excel"}</Button>
                </Tooltip>
                <Tooltip title={"Maak Matis-bestand met geselecteerde rijen"}>
                    <span>
                        <Button className={classes.exportButton} variant="contained" onClick={exportRows} disabled={selection.length === 0 || !props.user.isInterCommunales}>{"Maak Matis-bestand"}</Button>
                    </span>
                </Tooltip>

                <Button className={classes.AddButton} variant="contained" onClick={addRow} disabled={!props.user.isInterCommunales}>{"Toevoegen"}</Button>
            </div>

            <Paper className={classes.paper}>
                <DevExDataTable classname={classes.table} hasActions={true} ActionFormatter={ActionFormatter} sentToMatisFormatter={sentToMatisFormatter} priceFormatter={priceFormatter} quantityFormatter={quantityFormatter} columns={columns} data={rows} editRow={editRow} deleteRow={deleteRow} setSelection={setSelection} selection={selection}></DevExDataTable>
                <DeleteDialog open={openDeleteDialog} id={deleteId} toBeDeleted={toBeDeleted} handleClose={handleClose} handleDelete={handleDelete}></DeleteDialog>
                <AlreadyExistsDialog open={openAlreadyExistsDialog} handleClose={handleCloseDialog} handleSave={handleSaveDialog} handleCombine={handleCombine} objectToSave={objectToSave} foreignObjects={foreignObjects} existingRegistration={existingRegistration}></AlreadyExistsDialog>
                <AlreadySentDialog open={openRegistrationAlreadySentDialog} handleClose={handleCloseSentDialog} handleSave={handleSaveDialog} handleCombine={handleCombine} objectToSave={objectToSave} foreignObjects={foreignObjects} existingRegistration={existingRegistration}></AlreadySentDialog>

            </Paper>
            <ImportExcelModal user={props.user} appSettings={props.appSettings} handleOpenImport={handleOpenImport} customerId={customerId} handleCloseImport={handleCloseImport} open={openImport}></ImportExcelModal>

            <CrudAddEditDrawer setOpenAlreadyExistsDialog={setOpenAlreadyExistsDialog} setRegistrationAlreadySent={setRegistrationAlreadySent} setExistingRegistration={setExistingRegistration} setObjectToSave={setObjectToSave} setReload={setReload} foreignObjects={foreignObjects} user={props.user} title={crudTitle} openDrawer={openDrawer} columns={drawerColumns} drawerOpen={drawerOpen} editId={editId} rows={rows}></CrudAddEditDrawer>
        </div>
    )
}

const useStyles = makeStyles(() => ({
    container: {
        padding: "50px"
    },
    table: {
        height: '100%'
    },
    AddButton: {
        marginBottom: '25px',
        backgroundColor: '#1F8FA5',
        color: 'white'
    },
    exportButton: {
        marginBottom: '25px',
        backgroundColor: '#1F8FA5',
        color: 'white',
        marginRight: '10px',
    },
    buttonContainer: {
        textAlign: 'right'
    },
    actionButton: {
        color: '#1F8FA5',
    }
}));